<template>
  <v-container>
    <!-- <v-row class="search " align="center" justify="center">
      <span class="search-title">
       {{ $t("carrentalsearch") }}
      </span>
      <div>
        <v-text-field
            class="search-input"
            label="What kind of car are you looking for?"
            solo
            flat
            outlined
            v-model="form.search_str"
            hide-details
        >
          <div slot="append">
            <v-btn
                elevation="2"
                rounded
                dark
                class="search-btn d-none d-sm-block"
                color="#1b1b1b"
                @click="$emit('search')"
            >
              {{ $t("search") }}
            </v-btn>
            <v-btn
                elevation="2"
                rounded
                dark
                class="search-btn d-block d-sm-none"
                color="#1b1b1b"
                @click="$emit('search')"
            >
              <v-icon dark>
                fas fa-search
              </v-icon>
            </v-btn>
          </div>


        </v-text-field>
      </div>

    </v-row> -->
    <v-row class="mx-3 mx-sm-n8" align="center" justify="center">
      <v-item-group multiple v-model="activeBrand">
        <v-container>
          <v-row align="center"  class="flex-scroll">
            <template v-for="(item,i) in brandList">
              <v-item v-slot="{ active, toggle }" :key="i">
                <v-card class="sign mx-3" :class="active?'active-brand':''" :color="active ? 'grey lighten-1' : ''"
                        @click="searchCar(item,toggle)">
                  <v-img eager contain class="sign-img" width="117px" height="87px" :src="item.brand_logo"></v-img>
                  <v-row justify="center" class="brand-name">
                    {{ item.brand_name }}
                  </v-row>
                </v-card>

              </v-item>
            </template>

          </v-row>
        </v-container>
      </v-item-group>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SearchCar',
  props: {
    value: Object
  },
  watch: {
    value(val) {
      this.$set(this, 'form', val)
      // this.form = val
    },
    form: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true
    },
    activeBrand(val) {
      this.form.brand_id = val.map(i => {
        return this.brandList[i].id
      })
    }
  },
  data: function () {
    return {
      form: this.value,
      "brandList": [],
      "categoryList": [],
      activeBrand: []
    }
  },
  methods: {
    searchCar(item, toggle) {
      toggle()
    },
    goto(path) {
      this.$router.push(`/${path}`)
    }
  },
  mounted() {
    this.$api.fetch('/home/getBrandAndCategory', { //
    }).then((res) => {
      // console.log(res)
      this.brandList = res.brandList.splice(0, 8)
      this.categoryList = res.categoryList
    })
  }
}
</script>
<style scoped lang="scss">
.search {
  margin-bottom: 42px;
}

@media screen and (max-width:600px) {
  .search-input {
    width: 90vw!important;
  }
  .search-title {
    width: 100%!important;
    height: 33px;
    margin-left: 12px!important;
    margin-bottom: 12px;
    font-family: Poppins, Poppins;
    font-weight: 600;
    font-size: 24px;
    color: #3B3A40;
    line-height: 35px;
    text-align: left!important;
    font-style: normal;
  }
  .flex-scroll{
    flex-wrap: nowrap;
    overflow: scroll;
  }
  .sign{
    width: 86px!important;
    height: 86px!important;
    background: #F1F2F3!important;
    border-radius: 11px!important;
  }
  .sign-img{
    width: 67px!important;
    height: 30px!important;
  }
}
.search-title {
  width: 219px;
  height: 33px;
  margin-right: 63px;
  font-family: Poppins, Poppins;
  font-weight: 600;
  font-size: 24px;
  color: #3B3A40;
  line-height: 35px;
  text-align: center;
  font-style: normal;
}

.search-input {
  width: 555px;
  border-radius: 18px;
}

.search-btn {
  height: 23px;
  font-family: Poppins, Poppins;
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 25px;
  text-shadow: 0px 10px 30px rgba(0, 0, 0, 0.08);
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.sign {
  width: 140px;
  height: 147px;
  background: #F1F2F3;
  border-radius: 20px;
  padding: 19px 15px 20px 15px;
  margin-bottom: 40px;
  &:focus:before{
    display: none!important;
  }
  &:before{
    display: none!important;
  }
}

.brand-name {
  margin-top: 6px;
  font-size: 11px;
}

.active-brand {

}
</style>
